import {
  DELETE_ALARM_STATE,
  RECEIVE_ALARM_STATES,
  RECEIVE_AND_CLEAR_SITE_ALARM_STATES,
  REQUEST_SITE_GROUP_ALARM_STATES,
} from '@sophocles/entities/AlarmState/alarmStateActions';
import { Map } from 'immutable';

function getState(state, action) {
  switch (action.type) {
    case RECEIVE_ALARM_STATES:
      return state.merge(action.alarmStates);
    case RECEIVE_AND_CLEAR_SITE_ALARM_STATES:
      const siteFilteredAlarmStates = state.filter(alarmState => alarmState.get('site', 0) != action.site);
      return siteFilteredAlarmStates.merge(action.alarmStates);
    case DELETE_ALARM_STATE:
      return state.delete(action.alarmState.toString());
    case REQUEST_SITE_GROUP_ALARM_STATES:
    default:
      return state;
  }
}

export function alarmStateReducer(state = Map(), action) {
  switch (action.type) {
    case RECEIVE_ALARM_STATES:
    case DELETE_ALARM_STATE:
    case REQUEST_SITE_GROUP_ALARM_STATES:
    case RECEIVE_AND_CLEAR_SITE_ALARM_STATES:
      return getState(state, action);
    default:
      return state;
  }
}
